/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, forwardRef } from "react";
import { getBankAccounts } from "./../../../helpers/banking";
import { useSelector } from "react-redux";
import { Button, Typography, Skeleton, Paper, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Link as MuiLink } from "@mui/material";
import { Link } from "react-router-dom";

const ForwardNavLink = forwardRef((props, ref) => (
  <Link {...props} innerRef={ref} />
));

const List = () => {
  // state
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);

  // redux
  const { app } = useSelector((state) => state);

  useEffect(() => {
    handleGetBankAccounts();
  }, []);

  // methods
  const handleGetBankAccounts = async () => {
    try {
      const [, response] = await getBankAccounts(app.token);
      setList(response.data);
      setLoading(false);
    } catch(err) {
      console.log(err);
      setLoading(false);
    }
  }

  return (
    <div className="row">
      <div className="col-12">
        <div className="d-flex align-items-center mb-3 justify-content-between">
          <Typography variant="h6" fontWeight={700}>
            My Bank Accounts
          </Typography>
          <Button 
            size="small" 
            variant="contained" 
            component={Link} 
            className="ms-3"
            to={"/dashboard/bank/new"}
            >Add New
          </Button>
        </div>
        <TableContainer component={Paper}>
          <Table size="small" sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>Bank</TableCell>
                <TableCell align="right">Last 4</TableCell>
                <TableCell align="right">Routing</TableCell>
                <TableCell align="right">Account Holder</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan="4">
                    <Skeleton/>
                    <Skeleton/>
                    <Skeleton/>
                  </TableCell>
                </TableRow>
              )}
              {!loading && list.length === 0 && (
                <TableRow>
                  <TableCell className="text-center" sx={{ border: 0 }} colSpan={4}>
                    <Typography my={2} variant="body2">You don't have any bank accounts. <br/><MuiLink component={ForwardNavLink} to="/dashboard/bank/new">Add New</MuiLink></Typography>
                  </TableCell>
                </TableRow>
              )}
              {
                (!loading && list.length > 0) && (
                  <>
                    {list.map((item,i) => (
                      <TableRow
                        hover={true}
                        key={i}
                        sx={{ 
                          '&:last-child td, &:last-child th': { border: 0 },
                        }}
                      >
                        <TableCell>
                          {item.bank}
                        </TableCell>
                        <TableCell align="right">{item.last4}</TableCell>
                        <TableCell align="right">{item.routing}</TableCell>
                        <TableCell align="right">{item.name}</TableCell>
                      </TableRow>
                    ))}
                  </>
                )
              }
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};
export default List;


